export class SocialFriendItem extends PIXI.Container {
    constructor(data) {
        super();
        const ico = PIXI.Sprite.from(data.photo_100);
        ico.width = 100;
        ico.height = 100;
        this.addChild(ico);
        const text = new PIXI.Text(`ID: ${data.id}`, { fill: 0xffffff, fontSize: 14 });
        text.x = 50 - text.width / 2;
        text.y = 100 - text.height;
        this.addChild(text);
    }
}